import * as navConstants from '../routing.const';
import { SharedChannelGuard } from '../guards/shared-channel-guard.service';
import { Route } from '@angular/router';
import { SharedSignInGuard } from '../guards/shared-sign-in-guard.service';
import { SharedDepotSelectionGuard } from '../guards/shared-depot-selection-guard.service';
import { SharedEquipmentSelectionGuard } from '../guards/shared-equipment-selection-guard.service';

export const appRoutes: Route[] = [
  {
    path: 'tabs',
    loadComponent: () => import('../../navigation/tabs/tabs.page').then(c => c.TabsPage),
    canActivate: [SharedChannelGuard],
    loadChildren: () => [
      {
        path: navConstants.navSectionHme,
        loadChildren: () => import(`./routes.hme`).then(m => m.hmeRoutes),
        canActivate: [
          SharedChannelGuard,
          SharedSignInGuard,
        ],
      },
      {
        path: navConstants.navSectionHmeSignIn,
        loadComponent: () => import(`../../../pages/hme-sign-in/hme-sign-in.page`).then(c => c.HmeSignInPage),
        canActivate: [
          SharedChannelGuard,
        ],
      },
      {
        path: navConstants.navSectionDsh,
        loadChildren: () => import(`./routes.dsh`).then(m => m.dshRoutes),
        canActivate: [
          SharedChannelGuard,
          SharedSignInGuard,
          SharedDepotSelectionGuard,
          SharedEquipmentSelectionGuard,
        ],
      },
      {
        path: navConstants.navSectionSta,
        loadChildren: () => import(`./routes.sta`).then(m => m.staRoutes),
        canActivate: [
          SharedChannelGuard,
          SharedSignInGuard,
          SharedDepotSelectionGuard,
          SharedEquipmentSelectionGuard,
        ],
      },
      {
        path: navConstants.navSectionOut,
        loadChildren: () => import(`./routes.out`).then(m => m.outRoutes),
      },
      {
        path: navConstants.navSectionInf,
        loadChildren: () => import(`./routes.inf`).then(m => m.infRoutes),
        canActivate: [
          SharedChannelGuard,
          SharedSignInGuard,
          SharedDepotSelectionGuard,
          SharedEquipmentSelectionGuard,
        ],
      },
      {
        path: navConstants.navSectionOrd,
        loadChildren: () => import(`./routes.ord`).then(r => r.ordRoutes),
        canActivate: [
          SharedChannelGuard,
          SharedSignInGuard,
          SharedDepotSelectionGuard,
          SharedEquipmentSelectionGuard,
        ],
      },
      {
        path: navConstants.navSectionQua,
        loadChildren: () => import(`./routes.qua`).then(m => m.quaRoutes),
        canActivate: [
          SharedChannelGuard,
          SharedSignInGuard,
          SharedDepotSelectionGuard,
          SharedEquipmentSelectionGuard,
        ],
      },
      {
        path: navConstants.navSectionRfr,
        loadChildren: () => import(`./routes.rfr`).then(m => m.rfrRoutes),
        canActivate: [
          SharedChannelGuard,
          SharedSignInGuard,
          SharedDepotSelectionGuard,
          SharedEquipmentSelectionGuard,
        ],
      },
      {
        path: '',
        redirectTo: navConstants.navHmeUrl,
        pathMatch: 'full',
      },
      {
        path: navConstants.navSectionTar,
        loadChildren: () => import(`./routes.tar`).then(m => m.tarRoutes),
        canActivate: [
          SharedChannelGuard,
          SharedSignInGuard,
          SharedDepotSelectionGuard,
          SharedEquipmentSelectionGuard,
        ],
      },
      {
        path: navConstants.navSectionRfrMon,
        loadChildren: () => import(`./routes.rfr-mon`).then(m => m.rfrMonRoutes),
        canActivate: [
          SharedChannelGuard,
          SharedSignInGuard,
          SharedDepotSelectionGuard,
          SharedEquipmentSelectionGuard,
        ],
      }
    ],
  },
  {
    path: navConstants.navSectionWlc,
    loadComponent: () => import('@softpak/components/spx-welcome').then(c => c.SpxWelcomeComponent),
  },
  {
    path: '',
    loadComponent: () => import('@softpak/components/spx-update').then(c => c.SpxUpdatePageComponent),
        pathMatch: 'full',
        data: {
            url: navConstants.navHmeUrl,
        }
  },
];
